export default "__VITE_ASSET__DD0MB5id__"